// The monthly check-in, read with the same code WF78 triages and labels it with (scripts/checkin-rows.mjs).

import {
  CHECKIN_INTAKE_TYPES, CHECKIN_RED_CHIPS, checkinChips, hasCheckinRedFlag, isCheckinReply, labelCheckinRow,
} from '../../../scripts/checkin-rows.mjs';

export {
  CHECKIN_INTAKE_TYPES, CHECKIN_RED_CHIPS, checkinChips, hasCheckinRedFlag, isCheckinReply, labelCheckinRow,
};

export type CheckinIntakeType = (typeof CHECKIN_INTAKE_TYPES)[number];

export function isCheckinIntakeType(type: unknown): type is CheckinIntakeType {
  return (CHECKIN_INTAKE_TYPES as readonly unknown[]).includes(type);
}

// WF78's care-team tasks: a copy, because scripts/checkin-reader.mjs is workflow-only. S-163 §2 pins the two together.
export const CHECKIN_TASK_CODES: readonly string[] = ['exc_checkin_red_flag', 'exc_checkin_review', 'cc_checkin_device'];

export function isCheckinTask(code: unknown): boolean {
  return typeof code === 'string' && CHECKIN_TASK_CODES.includes(code);
}
